import Bugsnag from "@bugsnag/js";

export default function logError(error: Error): void {
  Bugsnag.notify(error);
}
